const ImagePreviewModal = ({ show, imageUrl, onClose, title = "Image Preview" }) => {
  if (!show) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.6)",
        backdropFilter: "blur(8px)",
        zIndex: 9999,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "20px",
        cursor: "pointer",
      }}
    >
      <img
        src={imageUrl}
        alt={title}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "90vw",
          maxHeight: "90vh",
          objectFit: "contain",
          borderRadius: "8px",
          cursor: "default",
        }}
      />
    </div>
  );
};

export default ImagePreviewModal;